module.exports = __webpack_public_path__ + "static/media/icon_sort.aafa5d7d.svg";